import { Box, Typography, useTheme } from "@mui/material";
import SearchOffIcon from "@mui/icons-material/SearchOff";
import BarChartIcon from "@mui/icons-material/BarChart";
import TableChartIcon from "@mui/icons-material/TableChart";

type EmptyStateVariant = "chart" | "table" | "search" | "default";

interface EmptyStateProps {
  message?: string;
  subMessage?: string;
  variant?: EmptyStateVariant;
  minHeight?: number | string;
}

const variantIcons: Record<EmptyStateVariant, React.ReactNode> = {
  chart: <BarChartIcon sx={{ fontSize: 48 }} />,
  table: <TableChartIcon sx={{ fontSize: 48 }} />,
  search: <SearchOffIcon sx={{ fontSize: 48 }} />,
  default: <SearchOffIcon sx={{ fontSize: 48 }} />,
};

const EmptyState: React.FC<EmptyStateProps> = ({
  message = "데이터가 없습니다",
  subMessage,
  variant = "default",
  minHeight = 200,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        width: "100%",
        backgroundColor: theme.palette.grey[50],
        borderRadius: 2,
        border: `1px dashed ${theme.palette.grey[300]}`,
        padding: 4,
        gap: 1.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: 80,
          height: 80,
          borderRadius: "50%",
          backgroundColor: theme.palette.grey[100],
          color: theme.palette.grey[400],
        }}
      >
        {variantIcons[variant]}
      </Box>
      <Typography
        variant="subtitle1"
        sx={{
          fontWeight: 600,
          color: theme.palette.grey[600],
          textAlign: "center",
        }}
      >
        {message}
      </Typography>
      {subMessage && (
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.grey[500],
            textAlign: "center",
            maxWidth: 280,
          }}
        >
          {subMessage}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState;
